import { match, Right } from "@insightfulscience/shared-utils/either";

import routes from "../routes";
import { followToReturlUrl } from "../routing-utils";
import { errorToLeft, globalGqlErrors } from "../utils/gql";

export const EALREADY_EXISTS_CUSTOMER = "errors.EALREADY_EXISTS_CUSTOMER";
export const EINVALID_PASSWORD_STRENGTH = "errors.EINVALID_PASSWORD_STRENGTH";

/**
 * Tries to register and redirects to /account if succeeded
 *
 * @type {
		(form: { firstName: string; lastName: string; company: string; email: string; password: string; }) =>
			(container: { authService: any; }) =>
				Promise<import("../utils-shared/either").Either<boolean, void>>
	} */
export const signUpFormAction = (
	{ firstName, lastName, company, email, password },
	turingToken,
	turingType,
) => ({ authService }) =>
	authService
		.signUp(firstName, lastName, company, email, password, turingToken, turingType)
		.then(
			match(errorCode => {
				throw errorCode;
			}, followToReturlUrl({ fallback: routes.myAccount })),
		)
		.then(Right)
		.catch(errorToLeft(globalGqlErrors));
